import { Location, PathLocationStrategy, PlatformLocation } from '@angular/common';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '../configuration/configuration.service';

@Injectable()
export class CustomLocationStrategy extends PathLocationStrategy {
  constructor(
    private readonly platform: PlatformLocation,
    private readonly configService: ConfigurationService
  ) {
    super(platform);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  override pushState(state: any, title: string, path: string): void {
    const url =
      window.location.origin + this.configService.getValueOrBlank(configuration.ConfigMeta.OEL_SPA_BASE_URL) + path;
    this.platform.pushState(state, title, url);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  override replaceState(state: any, title: string, path: string): void {
    const url =
      window.location.origin + this.configService.getValueOrBlank(configuration.ConfigMeta.OEL_SPA_BASE_URL) + path;
    this.platform.replaceState(state, title, url);
  }

  override path(includeHash = false): string {
    let pathname = this.platform.pathname + Location.normalizeQueryParams(this.platform.search);
    const hash = this.platform.hash;
    pathname = pathname.replace(this.configService.getValueOrBlank(configuration.ConfigMeta.OEL_SPA_BASE_URL), '');
    return hash && includeHash ? `${pathname}${hash}` : pathname;
  }
}
